import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {ItemModule} from '../../../../../core/component/item/item.module';
import {PartnerSummaryItemComponent} from './partner-summary-item.component';
import {PartnerSummaryModule} from '../partner-summary/partner-summary.module';
import {ButtonModule} from '../../../../../core/component/button/button.module';
import {
    SendEmailDialogModule
} from '../../../../../communication/email/api/component/send-email-dialog/send-email-dialog.module';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        ItemModule,
        PartnerSummaryModule,
        ButtonModule,
        SendEmailDialogModule,
    ],
    declarations: [
        PartnerSummaryItemComponent,
    ],
    exports: [
        PartnerSummaryItemComponent
    ],
})
export class PartnerSummaryItemModule{}
